import styled from "styled-components";

export const RightContentContainer= styled.div`
    flex: 1;
    background: #fafafa;
    overflow: hidden;
    scroll-behavior: smooth;
`;

export const HelpSection = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f5f5f5;
    padding: 15px;
    border-radius: 100px;
    margin: 20px 100px;
    max-width: 60%;
    font-size: 16px;
    color: #333;

    span {
        margin-right: 10px;
    }

    a {
        color: #2251FF;
        text-decoration: none;
    }

    a:hover {
        text-decoration: underline;
    }
`;

export const VisualizeByNameContentContainer = styled.div`

  flex : 1;
  max-width : 1200px;
  padding : 32px 32px 48px;
 
  display: flex;
  flex-direction: column;

  .loadingWrapper{
    width : 100%;
    min-height: calc(100vh - 400px); 
    display: flex;
    align-items: center;
    justify-content: center;
    svg{
        animation : spin 1s linear infinite;
    }
    @keyframes spin{
        to{
            transform : rotate(360deg)
        }
    }
  }
  .hideChildren {
    display: none;
  }

  >img{
    width : 100%;
  }

  nav{
    margin-bottom : 16px;
  }

  .chartTitle {
    margin-bottom: 16px;
    color: #1f1f1f;
    font-size: 16px;
    line-height: 24px;
  }
  
  li:last-of-type a{
    font-weight : 400;
  }

  a:first-letter{
    text-transform : uppercase;
  }

`;